export { formatPhone } from "@wato/phone";

/** HUNT-02: a 15+ digit WhatsApp LID-style id is not a dialable E.164 number (max 15 digits incl. country code, real ones are shorter in SA/BH). */
export function isLidLike(e164: string | null | undefined): boolean {
  return (e164 ?? "").replace(/\D/gu, "").length >= 15;
}

/** Up to two initials from a display name, or "" when none (caller shows a person icon). */
export function initialsOf(name: string | null | undefined): string {
  // A phone-like / masked number as the name has no initials (avoid a lone "9" avatar).
  const raw = (name ?? "").trim();
  if (/^[+\d]/u.test(raw) || /[·•*]/u.test(raw)) return "";
  const words = (name ?? "")
    .trim()
    .split(/\s+/)
    .filter((w) => /[\p{L}\p{N}]/u.test(w));
  return words
    .slice(0, 2)
    .map((w) => Array.from(w.replace(/^[^\p{L}\p{N}]+/u, ""))[0] ?? "")
    .join("")
    .toUpperCase();
}

/** True when a display name is just the phone number (so showing both would duplicate it). */
export function nameIsPhone(name: string | null | undefined, phoneE164: string | null | undefined) {
  if (!name || !phoneE164 || !/^[\s+\d()-]+$/u.test(name)) return false;
  const digits = (s: string) => s.replace(/\D/gu, "");
  const n = digits(name);
  return n !== "" && digits(phoneE164).endsWith(n.replace(/^0+/u, ""));
}

/**
 * NAME-01: the contact name to show, or null when it is missing, a privacy-masked placeholder
 * ("+973∙∙∙∙∙∙34") or just a phone number. Callers fall back to the formatted phone + person icon.
 */
export function realName(name: string | null | undefined): string | null {
  const raw = (name ?? "").trim();
  if (raw === "") return null;
  if (/[∙·•●*]/u.test(raw) && /[\d+]/u.test(raw)) return null;
  if (/^[\s+\d()-]+$/u.test(raw) && raw.replace(/\D/gu, "").length >= 5) return null;
  return raw;
}
